import { h } from "preact";

import style from "./style.css";

const Letter = ({ letter, index, isActive = false, handleClick }) => {
  const classes = [style["alphabet__letter"]];
  if (isActive) {
    classes.push(style['active']);
  }
  return (
    <span
      key={index}
      class={classes.join(' ')}
      onClick={handleClick}
    >
      {letter}
    </span>
  );
}

export default Letter;
